import usePageParams from '@anm/hooks/usePageParams';

export const useCalendarLinkParams = (url: string) => {
  const { embed } = usePageParams();
  const slugs = url.split('/');

  const eventId = slugs.pop()?.replace('.json', '') as string;
  const weekDate = slugs.pop() as string;

  const noforward = 'yes'; // this will use history.back() api

  return { eventId, weekDate, noforward, ...(embed && { embed }) };
};
